<template>
  <svg
    v-if="filled"
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.54802 7.94977C6.37451 7.94977 6.2285 8.01074 6.15516 8.13005C6.07921 8.25329 6.091 8.41194 6.17153 8.57256L8.11944 11.9487C8.12271 11.9553 8.12271 11.9592 8.11944 11.9651L5.05845 17.3735C4.97857 17.5328 4.98249 17.6928 5.05845 17.816C5.13178 17.9347 5.26142 18.0127 5.43493 18.0127H8.31586C8.74669 18.0127 8.95425 17.7216 9.10157 17.4555C9.10157 17.4555 12.0951 12.1546 12.2117 11.9487C12.1999 11.9297 10.231 8.49061 10.231 8.49061C10.0876 8.23494 9.87091 7.94977 9.42895 7.94977H6.54802Z"
      :fill="color"
    />
    <path
      d="M18.651 4C18.2208 4 18.0342 4.27141 17.8797 4.54937C17.8797 4.54937 11.6733 15.5694 11.469 15.9313C11.4795 15.951 15.5625 23.4506 15.5625 23.4506C15.7053 23.7063 15.9259 24 16.3672 24H19.2449C19.4184 24 19.5539 23.9344 19.6273 23.8158C19.7039 23.6925 19.7019 23.53 19.6214 23.37L15.5599 15.9405C15.556 15.9346 15.556 15.9274 15.5599 15.9215L21.9386 4.62935C22.0184 4.47005 22.0204 4.30746 21.9445 4.18422C21.8711 4.06556 21.7349 4 21.5614 4H18.651Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7541 8.93965C10.5964 8.65841 10.358 8.34473 9.87184 8.34473H6.70282C6.51196 8.34473 6.35135 8.41179 6.27068 8.54304C6.18713 8.67861 6.2001 8.85312 6.28868 9.02979L8.43138 12.7436C8.43498 12.7508 8.43498 12.7551 8.43138 12.7616L5.06429 18.7109C4.97642 18.8861 4.98074 19.062 5.06429 19.1976C5.14496 19.3281 5.28757 19.414 5.47843 19.414H8.64745C9.12136 19.414 9.34968 19.0938 9.51173 18.801C9.51173 18.801 12.8046 12.97 12.9328 12.7436C12.9199 12.7227 10.7541 8.93965 10.7541 8.93965ZM11.6671 12.7476C11.4836 12.4274 11.2442 12.0093 11.0026 11.5875L9.79989 9.48686L9.79468 9.47775C9.78774 9.46538 9.78144 9.45441 9.77564 9.44473H7.79804L9.40071 12.2225L9.41549 12.2521C9.45123 12.3237 9.53408 12.505 9.53408 12.7529C9.53408 13.0126 9.44405 13.2037 9.39323 13.2953L9.38872 13.3034L6.55288 18.314H8.5233C8.53108 18.3008 8.53971 18.2857 8.54932 18.2683L8.55387 18.2601L10.2164 15.3163C10.7701 14.3359 11.3311 13.3426 11.6671 12.7476Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.6718 4.10431C18.8418 3.79855 19.047 3.5 19.5202 3.5H22.7217C22.9125 3.5 23.0623 3.57212 23.143 3.70264C23.2265 3.83821 23.2244 4.01705 23.1365 4.19228L16.12 16.6136C16.1157 16.6201 16.1157 16.628 16.12 16.6345L20.5876 24.807C20.6762 24.9829 20.6784 25.1618 20.5941 25.2974C20.5134 25.4279 20.3643 25.5 20.1735 25.5H17.008C16.5226 25.5 16.2799 25.1769 16.1229 24.8957C16.1229 24.8957 11.6315 16.6461 11.62 16.6244C11.8447 16.2264 18.6718 4.10431 18.6718 4.10431C19.1645 4.38179 19.4039 4.51659 19.5202 4.58214C19.5295 4.5874 19.5381 4.59226 19.5459 4.59666C19.5459 4.59666 19.5459 4.59667 19.5459 4.59666L18.6718 4.10431ZM19.5519 4.6L19.6302 4.64411L19.6332 4.63878C19.6412 4.62443 19.6485 4.61157 19.6551 4.6H21.6428L15.1675 16.0633C14.9688 16.4062 14.9665 16.8286 15.1608 17.1732L19.1115 24.4H17.1068C17.1005 24.3895 17.0935 24.3776 17.0858 24.3639L13.2946 17.4C13.1314 17.1002 12.9899 16.8403 12.8774 16.6337C13.4702 15.5814 14.8382 13.1526 16.1886 10.7549L19.6302 4.64411C19.6303 4.64407 19.6303 4.64417 19.5519 4.6Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 28
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
